import { ReactElement } from 'react';
import { CopyableText } from '@client/common/components/CopyableText';
import { StockCount } from '@client/common/components/StockCount';
import { useTranslate } from 'b2b-apps/core/i18n/hooks';
import { Props } from './Features.types';
import './Features.scss';

export const Features = ({
  sku,
  manufacturerProductId,
  manufacturerPageUrl,
  onManufacturerPageClick,
  manufacturerUrl,
  manufacturerName,
  manufacturerWarranty,
  ean,
  quantityOrdered,
  stockCount,
  isSpecialOrder,
  soldSince,
  directDelivery,
}: Props): ReactElement => {
  const t = useTranslate();

  return (
    <table className='ProductData-Features cds-Table cds-Table--Features'>
      <tbody>
      <tr>
        <td>{t('SKU')}</td>
        <td><CopyableText className='cds-HideMobileNativeStyling'>{sku}</CopyableText></td>
      </tr>

      {
        manufacturerProductId ? (
          <tr>
            <td>{t('Manufacturer Product ID')}</td>
            <td>
              <CopyableText
                className='cds-HideMobileNativeStyling'>{manufacturerProductId}</CopyableText>
            </td>
          </tr>
        ) : null
      }

      <tr className='ProductData-Features--Truncated'>
        <td>{t('Manufacturer page')}</td>
        <td>
          <a
            className='cds-Link'
            href={manufacturerPageUrl}
            onClick={onManufacturerPageClick}
            rel='noopener noreferrer'
          >
            {manufacturerName}
          </a>
        </td>
      </tr>

      {
        manufacturerUrl ? (
          <tr className='ProductData-Features--Truncated'>
            <td>{t('Manufacturer link')}</td>
            <td>
              <a
                className='cds-Link'
                href={manufacturerUrl}
                target='_blank'
                rel='noopener noreferrer'
              >
                {manufacturerName}
              </a>
            </td>
          </tr>
        ) : null
      }

      <tr>
        <td>{t('Manufacturer warranty')}</td>
        <td>
          {manufacturerWarranty > 0
            ? t(['month', '{n} months', 'n'], { n: manufacturerWarranty })
            : t('0 months')
          }
        </td>
      </tr>

      <tr>
        <td>{t('Sold since')}</td>
        <td>{soldSince}</td>
      </tr>

      {
        ean ? (
          <tr>
            <td>{t('EAN')}</td>
            <td><CopyableText>{ean}</CopyableText></td>
          </tr>
        ) : null
      }

      <tr>
        <td>{t('Stock')}</td>
        <td>
          <StockCount
            isSpecialOrder={isSpecialOrder}
            quantityOrdered={quantityOrdered}
            stockCount={stockCount}
            isFullSize={true}
            directDelivery={directDelivery}
          />
        </td>
      </tr>
      </tbody>
    </table>
  );
};
